module.exports = {"env":"production","apiUrl":"https://api.gbc.pe"};